import React from 'react'
import CloseIcon from '@mui/icons-material/Close';

import styles from './styles.module.css';

const Modal = ({ isOpen, title, body, setOpenModal }: any) => {

    if(isOpen) {
        return (
            <div className={styles.modalBackground} >
                <div className={styles.modalCard}>
                    <div className={styles.closeModal} onClick={() => setOpenModal(!isOpen)}>
                        <CloseIcon onClick={() => window.location.reload()} style={{color: 'black'}}/>
                    </div>
                    <div className={styles.modalContent}>
                        <h1>{title}</h1>
                        <p>{body}</p>
                    </div>
                </div>
            </div>  
        )
    }  
    
    return null;
}

export default Modal
